const onElementShowExpand = (el, done) => {
	const height = el.scrollHeight
	const { paddingTop, paddingBottom } = getComputedStyle(el)
	el.style.overflow = 'hidden'
	el.style.height = '0'
	el.style.paddingTop = '0'
	el.style.paddingBottom = '0'
	requestAnimationFrame(() => {
		el.style.transition = 'height 0.35s ease, padding-top 0.35s ease, padding-bottom 0.35s ease'
		el.style.height = height + 'px'
		el.style.paddingTop = paddingTop
		el.style.paddingBottom = paddingBottom
		el.addEventListener('transitionend', () => {
			el.style.height = ''
			el.style.overflow = ''
			el.style.paddingTop = ''
			el.style.paddingBottom = ''
			done()
		}, { once: true })
	})
}

const onElementHideCollapse = (el, done) => {
	const { paddingTop, paddingBottom } = getComputedStyle(el)
	el.style.overflow = 'hidden'
	el.style.height = el.scrollHeight + 'px'
	el.style.paddingTop = paddingTop
	el.style.paddingBottom = paddingBottom
	requestAnimationFrame(() => {
		el.style.transition = 'height 0.35s ease, padding-top 0.35s ease, padding-bottom 0.35s ease'
		el.style.height = '0'
		el.style.paddingTop = '0'
		el.style.paddingBottom = '0'
		el.addEventListener('transitionend', () => {
			el.style.paddingTop = ''
			el.style.paddingBottom = ''
			done()
		}, { once: true })
	})
}

export { onElementShowExpand, onElementHideCollapse }
